export default __webpack_public_path__ + "static/media/tunnukset.add87021.png";